/** Bump when new-practice walkthrough content changes; keep in sync with server `constants/practiceWalkthrough.ts`. */
export const CURRENT_NEW_PRACTICE_TOUR_VERSION = 1;

/** Bump when in-session walkthrough content changes; keep in sync with server `constants/practiceWalkthrough.ts`. */
export const CURRENT_PRACTICE_SESSION_TOUR_VERSION = 1;
